import { ruPlural } from '@/lib/content/declension';
/**
 * UI-тексты агрегированного ledger тарифов eSIM (EsimPlansLedger).
 * Виджет-таблица: переключатель операторов, фильтры (покрытие/тип/звонки/оплата),
 * сортируемые колонки, кнопка «Выбрать». Только вертикаль-специфика.
 * Интерполируемые строки — функции.
 */
export const esimPlansLedger = {
    en: {
        // Operator switcher / filter controls
        all: 'All operators',
        fAll: 'All',
        type: 'Type',
        capped: 'Capped',
        payg: 'Pay-as-you-go',
        callsL: 'Calls',
        withCalls: 'With calls',
        payL: 'Payment',
        crypto: 'Crypto',
        // Column headers
        data: 'Data',
        days: 'Validity',
        coverage: 'Coverage',
        price: 'Price',
        perGB: 'Per GB',
        // Coverage / type labels
        local: 'Local',
        regional: 'Regional',
        global: 'Global',
        unlimited: 'Unlimited',
        // Units
        gbU: 'GB',
        mbU: 'MB',
        daysU: 'days',
        daysN: (n) => `${n} ${n === 1 ? 'day' : 'days'}`,
        // Row badges / actions
        best: 'Best',
        select: 'Select →',
        callsBadge: 'calls',
        callsTitle: 'Supports calls',
        // Empty / collapse
        empty: 'No plans match these filters',
        showAll: (n) => `Show all (${n})`,
        collapse: 'Collapse',
        // Filter spoiler
        filters: 'Filters',
        filtersHint: 'Coverage, type, calls and payment',
        // ARIA
        controlsAria: 'Operators and filters',
        operatorAria: 'Operator',
        recommendationsAria: 'Recommended eSIM plans',
        recUniversal: 'Best all-round',
        recValue: 'Best value',
        recUnlimited: 'Best unlimited',
        network: 'Network',
        hotspot: 'Hotspot',
        refund: 'Refund / guarantee',
        checked: 'Price checked',
        yes: 'Allowed',
        no: 'Not allowed',
        checkWithProvider: 'Confirm with provider',
        notProvided: 'Not specified',
    },
    ru: {
        all: 'Все операторы',
        fAll: 'Все',
        type: 'Тип',
        capped: 'Пакеты',
        payg: 'По факту',
        callsL: 'Звонки',
        withCalls: 'Со звонками',
        payL: 'Оплата',
        crypto: 'Криптовалюта',
        data: 'Данные',
        days: 'Срок',
        coverage: 'Покрытие',
        price: 'Цена',
        perGB: 'За ГБ',
        local: 'Локально',
        regional: 'Регион',
        global: 'Глобально',
        unlimited: 'Безлимит',
        gbU: 'ГБ',
        mbU: 'МБ',
        daysU: 'дней',
        daysN: (n) => `${n} ${ruPlural(n, ['день', 'дня', 'дней'])}`,
        best: 'Выгодно',
        select: 'Выбрать →',
        callsBadge: 'звонки',
        callsTitle: 'Поддерживает звонки',
        empty: 'Под фильтры ничего не нашлось',
        showAll: (n) => `Показать все (${n})`,
        collapse: 'Свернуть',
        filters: 'Фильтры',
        filtersHint: 'Покрытие, тип, звонки и оплата',
        controlsAria: 'Операторы и фильтры',
        operatorAria: 'Оператор',
        recommendationsAria: 'Рекомендуемые тарифы eSIM',
        recUniversal: 'Лучший универсальный',
        recValue: 'Самый выгодный',
        recUnlimited: 'Лучший безлимитный',
        network: 'Сеть',
        hotspot: 'Раздача интернета',
        refund: 'Возврат / гарантия',
        checked: 'Цена проверена',
        yes: 'Разрешена',
        no: 'Не разрешена',
        checkWithProvider: 'Уточнить у оператора',
        notProvided: 'Не указано',
    },
};
